import { useEffect } from "react";

function getTargetLang() {
  const userLang = (navigator.language || navigator.userLanguage || "fr").toLowerCase();

  if (userLang.startsWith("it")) return "it";
  if (userLang.startsWith("en")) return "en";
  if (userLang.startsWith("es")) return "es";
  if (userLang.startsWith("de")) return "de";
  if (userLang.startsWith("nl")) return "nl";
  if (userLang.startsWith("zh")) return "zh-CN";
  if (userLang.startsWith("ja")) return "ja";

  return "fr";
}

function setGoogTransCookie(lang) {
  const value = `/fr/${lang}`;
  const hostname = window.location.hostname;

  document.cookie = `googtrans=${value}; path=/;`;
  document.cookie = `googtrans=${value}; path=/; domain=${hostname};`;

  if (hostname.includes(".")) {
    document.cookie = `googtrans=${value}; path=/; domain=.${hostname};`;
  }
}

function clearGoogTransCookie() {
  const hostname = window.location.hostname;

  document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
  document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${hostname};`;

  if (hostname.includes(".")) {
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${hostname};`;
  }
}

export default function useMenuTranslate(isActive) {
  useEffect(() => {
    if (!isActive) {
      clearGoogTransCookie();
      return;
    }

    const targetLang = getTargetLang();

    // Important : on définit la langue AVANT de charger le widget
    setGoogTransCookie(targetLang);

    window.gtranslateSettings = {
      default_language: "fr",
      native_language_names: true,
      detect_browser_language: false,
      languages: ["fr", "en", "es", "it", "de", "nl", "zh-CN", "ja"],
      wrapper_selector: ".gtranslate_wrapper",
      switcher_horizontal_position: "right",
      switcher_vertical_position: "bottom",
    };

    const existingScript = document.querySelector(
      'script[src="https://cdn.gtranslate.net/widgets/latest/float.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://cdn.gtranslate.net/widgets/latest/float.js";
      script.defer = true;
      script.setAttribute("data-gtranslate", "true");
      document.body.appendChild(script);
    }

    return () => {};
  }, [isActive]);
}